import { Role } from "models/Role";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { getInvitationRoles } from "api/services/user-service";
import { useCallback, useEffect, useState } from "react";

export const useGetInvitationRoles = () => {
    const [invitationRoles, setInvitationRoles] = useState<Role[]>([]);
    const { callAPI, loading } = useWorkspaceApiCall(getInvitationRoles, '', 'getInvitationRoles.error');

    const fetchInvitationRoles = useCallback(async () => {
        const resp = await callAPI({});

        if (resp?.success && resp.data) {
            setInvitationRoles(resp.data);
        }
    }, [callAPI]);

    useEffect(() => {   
        fetchInvitationRoles();
    }, [fetchInvitationRoles]);

    return { invitationRoles, fetchInvitationRoles, fetchingInvitationRoles: loading };
}